module.exports = __webpack_public_path__ + "img/site_img.7a48bf22.jpg";